export default "__VITE_ASSET__5c802601__"